import { useMemo } from 'react';

import { DetailView } from '@kc-console/layout';

import DescriptionSectionContent from './DescriptionSectionContent';
import InfoSectionContent from './InfoSectionContent';
import RelatedServicesSectionContent from './RelatedServicesSectionContent';

import type { SectionItem } from '@kc-console/layout';
import type { EventDetail } from '@/pages/events/model/types';

interface EventDetailContentProps {
  event: EventDetail;
}

/**
 * 이벤트 상세 페이지 본문.
 * @description
 * - Anchor Tab 기반 DetailView에 세부 정보, 대상 서비스, 설명 섹션을 구성한다.
 * @example
 * <EventDetailContent event={event} />
 */
const EventDetailContent = ({ event }: EventDetailContentProps) => {
  const sections: SectionItem[] = useMemo(() => {
    const { eventStatus, relatedServices = [], eventComments = [] } = event;

    const sortedEventComments = eventComments.sort((a, b) => {
      return new Date(b.date || '').getTime() - new Date(a.date || '').getTime();
    });

    return [
      { header: '세부 정보', content: <InfoSectionContent event={event} /> },
      {
        header: '대상 서비스',
        headerEndAdornment: relatedServices.length > 0 ? relatedServices.length : undefined,
        content: (
          <RelatedServicesSectionContent services={relatedServices} eventStatus={eventStatus} />
        ),
      },
      {
        header: '설명',
        content: <DescriptionSectionContent comments={sortedEventComments} />,
      },
    ];
  }, [event]);

  return <DetailView sections={sections} />;
};

export default EventDetailContent;
